import { useState } from "react";

export default function Recover() {
  const [registrationId, setRegistrationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [score, setScore] = useState(null);
  const [error, setError] = useState(null);

  async function handleLookup(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setScore(null);

    try {
      const res = await fetch("/api/submissions/recover-score", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ registrationId }),
      });

      if (!res.ok) {
        throw new Error("Score not available yet.");
      }

      const data = await res.json();
      setScore(data.score);
    } catch (err) {
      setError(
        "We were unable to retrieve a score for this Registration ID at this time."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-xl w-full bg-white shadow-md rounded-lg p-6">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
          Submission Issue — Partial Recovery Available
        </h1>

        <p className="text-gray-700 mb-4">
          There was a technical problem while saving your submission.
          We were able to recover <strong>part of your work</strong>.
        </p>

        <p className="text-gray-700 mb-6">
          Enter your <strong>Registration ID</strong> below to view your
          <strong> overall score</strong>, if available.
        </p>

        <form onSubmit={handleLookup} className="space-y-4">
          <input
            type="text"
            value={registrationId}
            onChange={(e) => setRegistrationId(e.target.value)}
            placeholder="Registration ID"
            required
            className="w-full border rounded px-3 py-2"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded disabled:opacity-50"
          >
            {loading ? "Checking…" : "View Score"}
          </button>
        </form>

        {score != null && (
          <div className="mt-6 text-center">
            <div className="text-sm text-gray-600">Recovered Score</div>
            <div className="text-3xl font-bold text-gray-800">
              {score}%
            </div>
            <div className="text-sm text-gray-500 mt-2">
              Detailed results may appear later.
            </div>
          </div>
        )}

        {error && (
          <div className="mt-6 text-sm text-red-600 text-center">
            {error}
          </div>
        )}

        <div className="mt-6 text-xs text-gray-500 text-center">
          No further action is required from you right now.
        </div>
      </div>
    </div>
  );
}
